import {
  isClientSideRendering
} from "@/ssr-utils/ssr-env";

if (isClientSideRendering()) {
  // https://developer.mozilla.org/en-US/docs/Web/API/NodeList/forEach#Polyfill
  if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = Array.prototype.forEach;
  }
}
